export const environment = {
  production: true,
  apiUrl: 'https://api-vsstocks.digi-mapps.com/api'
};

